import { configureStore, Middleware } from '@reduxjs/toolkit';
import { logger } from 'kmstack-shared/core';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { rootReducer } from 'kmstack-shared/state/store';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['kmstack', 'kmstackTest'],
  stateReconciler: autoMergeLevel2,
  debug: true,
};

// Create the persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer as any);

// Define custom middleware
const customMiddleware: Middleware[] = []; // Add your custom middleware here

// Create the store with the appropriate middleware
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST'],
      },
    })
      // .concat(thunk as unknown as ThunkMiddleware)
      .concat(customMiddleware),
  // Other configuration options if needed
});

// Create the persistor (browser-only app, so always create it)
const persistor = persistStore(store);

store.subscribe(() => {
  if (process.env.NODE_ENV === 'development') {
    logger.dev('Store state after rehydration:', store.getState());
  }
});

export { store, persistor };
